// ====================================================
// Handles displaying correct price when switching Slick slide
window.addEventListener('DOMContentLoaded', function() {

  (function ProductPriceSwitcher() {

    // Get product variants' prices
    const thisCode = document.getElementById('page-product-code');
    const variantPrices = thisCode.dataset.prices.split('|');

    // Get relevant elements
    const sectionId = document.querySelector('.product-section').dataset.sectionId;
    const $slickElement = $('#ProductPhoto-' + sectionId);
    const $productPrice = $slickElement.find('.money');

    // Display correct price for selected variant
    $slickElement.on('beforeChange', function(_, _, _, nextSlide) {
      $productPrice.html(variantPrices[nextSlide]);
    });

  })();
  
  (() => {
   setTimeout(() => {
		document.querySelector(".popup_upsell-colors").children[0].click();
  }, 150)


  })();

  // ====================================================
  // Handles product color picker and slider image filtering
  (function ProductDetailsOptions() {
    setTimeout(() => {
// Fetch select element which holds product options
    const selector = $('.single-option-selector');
    if (!selector.length) {
      return;
    }

    // Fetch product handle from outputted product JSON
    const productJsonEl = document.querySelector('.product-json');
    const productHandle = JSON.parse(productJsonEl.innerHTML).handle;
    const isProductClocky = productHandle === 'clocky';

    function ProductOptionPicker(optionBaseClass) {
      this.optionBaseClass = optionBaseClass;
      this.onChangeCallback = null;

      const pickers = document.querySelectorAll(this.optionBaseClass);
      pickers.forEach(picker => {
        picker.onclick = () => this.selectOption(picker);
      });
    }

    // Handles selecting product color option
    ProductOptionPicker.prototype.selectOption = function(picked) {
      // Find previously selected and remove 'selected' class if it exists
      const previouslyPicked = document.querySelector(`${this.optionBaseClass}.selected`);
      if (previouslyPicked !== null) {
        previouslyPicked.classList.remove('selected');
      }

      // Add 'selected' class to selected option
      picked.classList.add('selected');

      // Update selector value so correct variant is sent to cart
      selector.val(picked.dataset.value).trigger('change');

      // Trigger onChangeCallback with selected color name
      if (typeof this.onChangeCallback === 'function')
        this.onChangeCallback(picked.dataset.value);
      
      let color = picked.dataset.value;
      
      
	
      
      for(const li of document.querySelectorAll(".slick-dots li")) {

        let target=color.toLowerCase();
        if (target=="blue-bluewheel"){
          target="bl_ue_bl_ue_wheel";
          
          
        }

        if (target=="black-blackwheel"){
          target="bla_ck_bla_ck_wheel";
         
          
        }
        if(li.children[0].getAttribute("src").toLowerCase().includes(target)) {
          
          console.log(target);
          console.log(li.children[0].getAttribute("src").toLowerCase());
        	li.style.display = "inline-block";
        } else {
        	li.style.display = "none";
        }
      }
    }

    // Initialize ProductOptionPicker
    let optionBaseClass = isProductClocky ? '.popup_upsell-color.product' : '.product_size-option';
    const optionPicker = new ProductOptionPicker(optionBaseClass);

    // Setup product image filtering if product is Clocky
    if (!isProductClocky) {
      return;
    }

    // Fetch Slick slider
    // const $slick = $('#ProductPhoto-product');
    const $slick = $('#Photo-product');

    // Fetch Slick slider thumbs and cache corresponding slides
    const thumbs = document.querySelectorAll('.slick-dots li');
    thumbs.forEach(thumb => thumb.thumbSlide = getThumbSlide(thumb));

    function getThumbSlide(thumb) {

      // Extract thumb image source without version information
      const image = thumb.querySelector('img');
      const index = image.src.indexOf('?v=');
      const needle = image.src.slice(0, index).replace('https:', '');

      // Fetch slide with thumbnail's image
      return document.querySelector(`.product__photo[data-thumb^="${needle}"]`)
    }


    // Displays all relevant images depending on the passed color
    function displayThumbs(color) {
      // Clear previous image filter
      $slick.slick('slickUnfilter');

      // Hide all thumbs if color is 'none'
      if (color === 'none') {
        thumbs.forEach(thumb => {
          thumb.style.display = 'none';
          thumb.thumbSlide.classList.remove('current');
        });
        return;
      }

      // Normalize color name
      color = color.toLowerCase();

     

      thumbs.forEach(thumb => {
        let source = thumb.querySelector('img').src.toLowerCase();
        const slide = thumb.thumbSlide;

        
        
        let target=color;
        if (color=="blue-bluewheel"){
          target="bl_ue_bl_ue_wheel";
          
          
        }

        else if (color=="black-blackwheel"){
          target="bla_ck_bla_ck_wheel";
         
          
        }
        
        // Display current thumbnail and add filter class
        if (source.includes(target)) {
          
          thumb.style.display = 'inline-block';
          thumb.thumbSlide.classList.add('current');
         
          
        }
        // Hide current thumbnail
        else {
          thumb.style.display = 'none';
          thumb.thumbSlide.classList.remove('current');
        }







        
      });

      // Only show slides with 'current' class
      $slick.slick('slickFilter', '.current');
    }

    // Set onChangeCallback
    optionPicker.onChangeCallback = displayThumbs;

    // Select correct slides on load
    const selectedOption = selector[0].querySelector('[selected="selected"]');
    const selectedThumb = document.querySelector(`${optionBaseClass}[data-value="${selectedOption.value}"]`);
    optionPicker.selectOption(selectedThumb);
               }, 150);
  })();


});
